/** As datas das tarefas como se dizem e como se agrupam. Uma data de tarefa é um dia, não um instante. */

export const toIsoDate = (date: Date): string => {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};

export const addDays = (date: Date, days: number): Date => {
  const next = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  next.setDate(next.getDate() + days);
  return next;
};

/** A segunda-feira seguinte (nunca hoje). */
export const nextMonday = (today: Date = new Date()): Date =>
  addDays(today, ((8 - today.getDay()) % 7) || 7);

/** "Hoje", "Amanhã", "Há 3 dias", "sexta-feira, 9 out" — a data como se diz, não como se escreve. */
export function describeDueDate(isoDate: string | null, today: Date = new Date()): string {
  if (!isoDate) return "Sem data";
  const [year, month, day] = isoDate.slice(0, 10).split("-").map(Number);
  const date = new Date(year, month - 1, day);
  const base = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const diff = Math.round((date.getTime() - base.getTime()) / 86_400_000);
  if (diff === 0) return "Hoje";
  if (diff === 1) return "Amanhã";
  if (diff === -1) return "Ontem";
  if (diff < -1) return `Há ${-diff} dias`;
  return date.toLocaleDateString("pt-PT", {
    weekday: diff < 7 ? "long" : "short",
    day: "numeric",
    month: "short",
  });
}

export type DueBucket = "overdue" | "today" | "tomorrow" | "week" | "later" | "none";

export const DUE_BUCKETS: { key: DueBucket; label: string }[] = [
  { key: "overdue", label: "Atrasadas" },
  { key: "today", label: "Hoje" },
  { key: "tomorrow", label: "Amanhã" },
  { key: "week", label: "Próximos 7 dias" },
  { key: "later", label: "Mais tarde" },
  { key: "none", label: "Sem data" },
];

export function dueBucket(isoDate: string | null, today: Date = new Date()): DueBucket {
  if (!isoDate) return "none";
  const iso = isoDate.slice(0, 10);
  const todayIso = toIsoDate(today);
  if (iso < todayIso) return "overdue";
  if (iso === todayIso) return "today";
  if (iso === toIsoDate(addDays(today, 1))) return "tomorrow";
  if (iso <= toIsoDate(addDays(today, 7))) return "week";
  return "later";
}
